import script from "./SecondPdfPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SecondPdfPage.vue?vue&type=script&setup=true&lang=ts"

import "./SecondPdfPage.vue?vue&type=style&index=0&id=2ed7f513&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed7f513"]])

export default __exports__